/**
 * Diák CRUD wrapper a FE-n.
 *
 * A pta_leader (free_text vagy institution-bound csoport) felveheti, szerkesztheti
 * és lifecycle-zheti a saját csoportja diákjait.
 *
 * Endpointok (BE):
 *  - POST   /groups/:id/students        — új diák egyben csoport-membership-pel
 *  - PATCH  /students/:id               — szerkesztés (csak institution-bound diák; admin-only most)
 *  - GET    /groups/:id/students        — csoport aktív tagjai (core-entities-ben már megvan)
 *
 * Free_text csoportos diákra PATCH most NEM működik — a BE 409-cel utasítja vissza.
 * Az UI ezt jelzi és a szerkesztés-gombot disabled-re teszi az ilyen diákoknál.
 */

import type {
  IdentityStatus,
  Student,
  StudentUpdateInput,
  GroupMembership,
} from '@pta/types';
import { apiCall } from './client';

/**
 * `POST /groups/:id/students` payload. A `validFrom` opcionális (default: ma).
 */
export interface AddStudentToGroupInput {
  educationalId?: string | null;
  identityStatus?: IdentityStatus;
  firstName: string;
  lastName: string;
  birthDate?: string | null;
  addressLine?: string | null;
  city?: string | null;
  postalCode?: string | null;
  notes?: string | null;
  validFrom?: string;
  reason?: string;
}

export interface AddStudentToGroupResult {
  student: Student;
  membership: GroupMembership;
}

export function addStudentToGroup(
  groupId: number,
  input: AddStudentToGroupInput,
): Promise<AddStudentToGroupResult> {
  return apiCall(`/groups/${groupId}/students`, { method: 'POST', body: input });
}

export function updateStudent(id: number, input: StudentUpdateInput): Promise<Student> {
  return apiCall(`/students/${id}`, { method: 'PATCH', body: input });
}
